/**
 * Types et constantes du radar de passage, partagés entre le serveur
 * (lib/run-activity.ts) et l'interface. Aucune dépendance serveur.
 */

/**
 * Les huit branches du radar, dans l'ordre des branches du logo (en partant du haut).
 * Stable ids: the labels live in the `dashboard.radar.families` dictionary.
 */
export const RADAR_FAMILIES = [
  "network",
  "hiring",
  "procurement",
  "press",
  "registries",
  "regulation",
  "events",
  "communities",
] as const;

export type RadarFamilyId = (typeof RADAR_FAMILIES)[number];

/**
 * Étapes d'un passage : en file, comprendre l'offre, explorer les sources,
 * retenir les signaux (rédaction du rapport), trouver les interlocuteurs,
 * terminé — ou interrompu.
 */
export type RunActivityPhase = "queued" | "understand" | "explore" | "retain" | "contacts" | "done" | "failed";

export type RunActivityEvent = {
  id: string;
  at: string;
  type: "search" | "read";
  /** Index dans RADAR_FAMILIES. */
  family: number;
  /** Requête d'une recherche, domaine d'une page lue. */
  label: string | null;
};

export type RunActivity = {
  runId: string;
  status: string;
  phase: RunActivityPhase;
  startedAt: string;
  completedAt: string | null;
  error: string | null;
  searches: number;
  pages: number;
  families: Array<{ searches: number; pages: number }>;
  /** Organisations retenues par le rapport (nouvelles, réactivées ou déjà connues). */
  retained: number;
  /** Nouveaux leads et leads réactivés : le chiffre du bilan. */
  leads: number;
  /** Organisations dont l'enrichissement a commencé. */
  enriched: number;
  events: RunActivityEvent[];
};
